import { truthy } from '@dmp/shared/helpers';
import type { StoreState } from '../../state-types';

/** Check card if it has (connection with) Poll Result */
export const checkCardHasPollResult =
    (cardId: string) =>
    (state: StoreState): boolean => {
        // collect all question ids from poll result card
        const pollResultCardsQuestionIds = state.survey.cardIds
            .map((id) => state.cards[id])
            .filter(truthy)
            .filter((c) => c.type === 'pollResultCard')
            .map((c) => c.questionId);

        return pollResultCardsQuestionIds.includes(cardId);
    };
